import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

import InputGroup from "./InputGroup";
import InvalidMessage from "./InvalidMessage";

export default function SelectInput(props) {
  const {
    userInput,
    onChange,
    stateKey,
    labelText,
    invalidMessage,
    validate,
    children
  } = props;

  return (
    <InputGroup labelText={labelText} name={stateKey}>
      <Input
        type="select"
        value={userInput.val}
        onChange={onChange.bind(null, stateKey)}
      >
        {children}
      </Input>
      {validate === false ? null : (
        <InvalidMessage isValid={userInput.isValid} message={invalidMessage} />
      )}
    </InputGroup>
  );
}

SelectInput.displayName = "SelectInput";

SelectInput.propTypes = {
  userInput: PropTypes.shape({
    isValid: PropTypes.bool,
    value: PropTypes.string
  }).isRequired,
  // stateKey maps to the key where the value is stored in state, and is bound to
  // the onChange handler
  stateKey: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  invalidMessage: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

SelectInput.defaultProps = {
  invalidMessage: "Invalid input"
};



// WEBPACK FOOTER //
// ./src/Shared/Forms/SelectInput.js